import { Stack } from '@mui/material'
import { GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid-pro'
import * as React from 'react'
import { stackGap } from '../../Constants&Theme/Spacing'

export const reportDGProps = {
  disableRowSelectionOnClick: true,
  disableColumnMenu: true,
  disableColumnSelector: true,
  slots: {
    toolbar: ReportProps,
  },
}
function ReportProps() {
  return (
    <GridToolbarContainer sx={{ width: 1, p: 1 }}>
      <Stack
        direction={'row'}
        gap={stackGap.row / 2}
        width={1}
        display={'flex'}
      >
        <GridToolbarExport
          csvOptions={{ allColumns: true }}
          printOptions={{ disableToolbarButton: true }}
        />
      </Stack>
    </GridToolbarContainer>
  )
}

export default ReportProps
